import { render, staticRenderFns } from "./RightColumnWidget.vue?vue&type=template&id=6753f626&"
import script from "./RightColumnWidget.vue?vue&type=script&lang=js&"
export * from "./RightColumnWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports